import { useTranslation } from 'react-i18next';
import { useUser } from 'services/User';
import { navigateToHomePage } from 'services/accessControl';

export const Logo = () => {
    const { t } = useTranslation();
    const { user } = useUser();

    const handleClick = () => {
        navigateToHomePage(user);
    };

    return (
        <button
            type='button'
            onClick={handleClick}
            aria-label={t('Go to Homepage')}
            data-testid='product-logo'
            className='tw:flex tw:items-center tw:w-180 tw:h-60 tw:bg-transparent tw:border-0 tw:p-0 tw:cursor-pointer'
        >
            <img
                src='/Cloud-logo-black.png'
                alt=''
                aria-hidden='true'
                className='tw:w-full tw:h-full tw:object-contain tw:dark:hidden'
            />
            <img
                src='/Cloud-logo-white.png'
                alt=''
                aria-hidden='true'
                className='tw:w-full tw:h-full tw:object-contain tw:hidden tw:dark:block'
            />
        </button>
    );
};
